import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ProjectService } from '@core/projects/project.service';

const APP_NAME = 'AM.One';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly projectService = inject(ProjectService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    if (!pageTitle) {
      this.title.setTitle(APP_NAME);
      return;
    }

    const projectId = this.findProjectId(snapshot.root);
    if (!projectId) {
      this.title.setTitle(pageTitle);
      return;
    }

    this.projectService.get$(projectId).subscribe({
      next: project => this.title.setTitle(`${pageTitle} | ${project.name}`),
      error: () => this.title.setTitle(pageTitle),
    });
  }

  private findProjectId(route: ActivatedRouteSnapshot | null): string | undefined {
    let current: ActivatedRouteSnapshot | null = route;
    while (current) {
      const id = current.paramMap.get('projectId');
      if (id) {
        return id;
      }
      current = current.firstChild;
    }
    return undefined;
  }
}
